import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

const _format = get(format);
//Pako-let's try to collect all errors.codes here with messages prepared for/or already translated
export const errors = (code, message) => {
	switch (code) {
		case '-106':
			return _format('alert_error_fw_update_in_progress', {
				default: 'Firmware update is already in progress.',
			});
		case '-114':
			return _format('alert_error_fw_update_not_found', {
				default: 'FW stage stable not found!',
			});
		case '-144':
			return _format('alert_error_fw_update_in_progress', {
				default: 'Firmware update is already in progress.',
			});
		case '-109':
			return _format('alert_error_too_low', { default: 'Current too low.' });
		default:
			return message; //because there are too many unknown codes at the moment so we can deliver the message
	}
};
